import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {BusinessDataService} from 'src/app/data-repositories/business-data.service';
import {User} from 'src/app/models/user';
import {ValidationInfoService} from 'src/app/repositories/validation-info.service';
import {StagesNavigationService} from './stages-navigation.service';
import {AccountType} from '../../../models/account-type';
import {Stage} from '../../../models/stage';

@Component({
  standalone: false,
  selector: 'app-stages-navigation',
  templateUrl: './stages-navigation.component.html',
  styleUrls: ['./stages-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class StagesNavigationComponent implements OnInit, OnDestroy {

  userModel: User;
  accountType = AccountType;
  private subscription = new Subscription();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private service: BusinessDataService,
    private validationInfo: ValidationInfoService,
    private changeDetectorRef: ChangeDetectorRef,
    public stagesNavigationService: StagesNavigationService) {
    this.subscription.add(stagesNavigationService.onChange.subscribe(() => {
      changeDetectorRef.detectChanges();
    }));
  }

  ngOnInit(): void {
    this.subscription.add(this.service.GetUser().subscribe(s => {
      this.userModel = s.model;
    }));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  navigateTo(stage: Stage) {
    this.validationInfo.resetAndValidate({isNavigate: true});

    if (this.validationInfo.getValidateState()) {
      window.scrollTo(0, 0);

      this.router.navigate([{outlets: {stages: stage.stageOutlet}}], {relativeTo: this.route});
      this.service.updateUserImmediatly(this.userModel);
    }
  }
}
